import { render, staticRenderFns } from "./VSelectAssociations.vue?vue&type=template&id=6e4836dc&scoped=true&"
import script from "./VSelectAssociations.vue?vue&type=script&lang=js&"
export * from "./VSelectAssociations.vue?vue&type=script&lang=js&"
import style0 from "./VSelectAssociations.vue?vue&type=style&index=0&id=6e4836dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4836dc",
  null
  
)

export default component.exports